import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface AdditionalFeaturesTabProps {
  formData: Record<string, any>;
  updateField: (field: string, value: any) => void;
  planType: string;
}

export function AdditionalFeaturesTab({ formData, updateField }: AdditionalFeaturesTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="portabilityAllowed"
          checked={formData.portabilityAllowed || false}
          onCheckedChange={(checked) => updateField("portabilityAllowed", checked)}
        />
        <div>
          <Label htmlFor="portabilityAllowed" className="cursor-pointer">
            Portability Allowed
          </Label>
          <p className="text-xs text-muted-foreground">
            Employee can keep coverage after leaving the group, at group rates for a limited period
          </p>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="conversionAllowed"
          checked={formData.conversionAllowed || false}
          onCheckedChange={(checked) => updateField("conversionAllowed", checked)}
        />
        <div>
          <Label htmlFor="conversionAllowed" className="cursor-pointer">
            Conversion Allowed
          </Label>
          <p className="text-xs text-muted-foreground">
            Employee can convert group policy to an individual whole life policy without medical underwriting
          </p>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="acceleratedDeathBenefit"
          checked={formData.acceleratedDeathBenefit || false}
          onCheckedChange={(checked) => updateField("acceleratedDeathBenefit", checked)}
        />
        <div>
          <Label htmlFor="acceleratedDeathBenefit" className="cursor-pointer">
            Accelerated Death Benefit
          </Label>
          <p className="text-xs text-muted-foreground">
            Allows early payout of a portion of the death benefit if the insured is diagnosed with a terminal illness
          </p>
        </div>
      </div>
    </div>
  );
}
